module.exports = __webpack_public_path__ + "img/modulo_Ubicacion.63b128d.svg";